import { BottomNavigationMobile } from "./BottomNavigation.mobile";
import { NavbarMobile } from "./Navbar.mobile";
import { FabMobile } from "./Fab.mobile";
import { MainMobile } from "./Main.mobile";
import { useBoundStore } from "@/app/store";

/**
 * Mobile layout with memoized components.
 * Components handle their own visibility and state from the store.
 */
export function PageLayoutMobile() {
  const resizeViewportOnKeyboardOpen = useBoundStore((state) => state.pageLayout.resizeViewportOnKeyboardOpen);

  return (
    <div
      className="mx-auto flex h-dvh max-w-5xl flex-col overflow-hidden"
      style={resizeViewportOnKeyboardOpen ? { height: "var(--viewport-height)" } : undefined}
    >
      <NavbarMobile />
      <MainMobile />
      <BottomNavigationMobile />
      <FabMobile />
    </div>
  );
}
